import React from "react";
import { useNavigate } from "react-router-dom";

const NaboraSectors = ({ data }) => {
  const navigate = useNavigate();

  const defaultData = {
    title: "Explore Nabora Sectors",
    subtitle:
      "Discover different business categories participating in neighbourhood digital exhibitions.",

    sectors: [
      {
        icon: "🥫",
        title: "FMCG & Food",
        desc: "Daily essentials, food brands, home-made products and local food entrepreneurs.",
        merchants: "120+ Merchants",
        route: "/nabora/exhibitions",
      },
      {
        icon: "👗",
        title: "Fashion & Lifestyle",
        desc: "Fashion brands, creators, boutiques and lifestyle products.",
        merchants: "90+ Brands",
        route: "/nabora/exhibitions",
      },
      {
        icon: "🧺",
        title: "Local Crafts & Handmade",
        desc: "Artisans, makers and traditional creators showcasing unique products.",
        merchants: "75+ Makers",
        route: "/nabora/exhibitions",
      },
      {
        icon: "💻",
        title: "Digital Services",
        desc: "Local professionals, creators and service providers.",
        merchants: "Growing Community",
        route: "/nabora/merchant",
      },
      {
        icon: "🌱",
        title: "Women Entrepreneurs",
        desc: "Women-led businesses building independent digital income streams.",
        merchants: "FoundHer Network",
        route: "/foundher",
      },
      {
        icon: "🎓",
        title: "Youth Creators",
        desc: "Students and young entrepreneurs creating local opportunities.",
        merchants: "Gen Z Ecosystem",
        route: "/nabora/organiser",
      },
    ],
  };

  const content = data || defaultData;

  const handleSectorAction = (sector) => {
    if (sector.route) {
      navigate(sector.route);
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 text-white">
      <div className="py-8 px-6 bg-gradient-to-br from-violet-950 via-purple-950 to-slate-950">
        <div className="max-w-5xl mx-auto text-center">
          <div className="uppercase tracking-[4px] text-yellow-300 text-sm mb-4">
            🎯 NABORA SECTORS
          </div>

          <h1 className="text-2xl lg:text-4xl font-bold mb-4">
            {content.title}
          </h1>

          <p className="text-slate-300 text-base lg:text-xl max-w-3xl mx-auto">
            {content.subtitle}
          </p>
        </div>
      </div>

      <div className="py-8 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {content.sectors.map((sector, index) => (
              <div
                key={index}
                className="bg-slate-900/80 rounded-3xl p-6 border border-white/10 hover:border-purple-400/50 transition-all"
              >
                <div className="text-5xl mb-4">{sector.icon}</div>

                <h2 className="text-cyan-200 text-lg lg:text-xl font-bold mb-3">
                  {sector.title}
                </h2>

                <p className="text-slate-300 text-sm mb-4">{sector.desc}</p>

                <div className="text-cyan-300 text-sm mb-4">
                  👥 {sector.merchants}
                </div>

                <button
                  onClick={() => handleSectorAction(sector)}
                  className="w-full px-4 py-2 rounded-xl bg-gradient-to-r from-fuchsia-500 to-violet-600 font-semibold hover:scale-105 transition-all"
                >
                  Explore Sector →
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="py-8 px-6 bg-gradient-to-br from-slate-900 to-violet-950">
        <div className="max-w-4xl mx-auto text-center">
          <div className="text-5xl mb-4">🚀</div>

          <h2 className="text-cyan-200 text-xl lg:text-3xl font-bold mb-3">
            Every Local Business Has A Place In Nabora
          </h2>

          <p className="text-slate-300 mb-6">
            From neighbourhood shops to creators and entrepreneurs, Nabora
            creates digital visibility for every sector.
          </p>

          <button
            onClick={() => navigate("/nabora/merchant")}
            className="px-6 py-3 rounded-xl border border-white/30 hover:bg-white/10 transition-all"
          >
            🏪 Join As Merchant
          </button>
        </div>
      </div>
    </div>
  );
};

export default NaboraSectors;
